import React, { useContext, useState } from 'react'

import PanelHeader from '../../../elem/panel/PanelHeader'
import { DataContext } from './DataContext'
import { DownArrow, UpArrow } from '../../../elem/Arrows'
import CollapseButton from '../../../elem/list/CollapseButton'
import ExpandButton from '../../../elem/list/ExpandButton'
import SaveAsImageButton from '../../../elem/chart/SaveAsImageButton'
import { filterModes } from '../box-plot/FilterModeSelector'
import { AppStateContext } from '../AppStateContext'
import { PanelStyleContext } from '../../../elem/panel/PanelStyleContext'

// import { IconTooltup as Tooltip } from '../../../elem/Tooltip'

const PiperHeader = () => {
    const {
        displayFilterModeDropdown,
        setDisplayFilterModeDropdown,
        filterMode,
        loading,
        saveAsImageRef,
        isCollapsed,
        setCollapsed,
    } = useContext(DataContext)
    const {
        mapState: { selectedFeatures },
    } = useContext(AppStateContext)
    const { isExpanded, setIsExpanded } = useContext(PanelStyleContext)

    return (
        <PanelHeader extraClass={'aggregatePanelHeader'}>
            <div className="panelHeaderText">Piper Diagram by Well Type</div>
            <div className="panelButtons">
                <SaveAsImageButton
                    name={`PiperDiagrambyWellType`}
                    componentRef={saveAsImageRef}
                    disabled={
                        loading ||
                        (!selectedFeatures.length &&
                            filterMode === filterModes[0])
                    }
                />
                <div
                    className="panelButton"
                    onClick={() =>
                        setDisplayFilterModeDropdown(!displayFilterModeDropdown)
                    }
                >
                    <span className="panelTimeOptionText">{filterMode}</span>
                    <span className="panelTimeOptionDropdown">
                        {displayFilterModeDropdown ? (
                            <UpArrow color={'white'} className={'is-white'} />
                        ) : (
                            <DownArrow color={'white'} className={'is-white'} />
                        )}
                    </span>
                </div>
                {isExpanded ? null : (
                    <CollapseButton
                        name={`piper`}
                        isCollapsed={isCollapsed}
                        setIsCollapsed={setCollapsed}
                    />
                )}
                <ExpandButton
                    name={`piper`}
                    isExpanded={isExpanded}
                    setIsExpanded={setIsExpanded}
                />
            </div>
        </PanelHeader>
    )
}

export default PiperHeader
